import { Card, Col, Row } from "react-bootstrap";
import { IThirdPartyCorrespondenceDetails } from "../../../api/IThirdPartyCorrespondence";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { ThirdPartyCorrespondenceIcon } from "../../../leap-components/icons/LeapIcons";

interface ThirdPartyCorrespondenceHeaderProps {
  thirdPartyCorrespondence: IThirdPartyCorrespondenceDetails;
}

const ThirdPartyCorrespondenceHeader = ({
  thirdPartyCorrespondence,
}: ThirdPartyCorrespondenceHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <ThirdPartyCorrespondenceIcon />
                  </td>
                  <td>
                    <h2>
                      Third Party Correspondence:{" "}
                      {thirdPartyCorrespondence.reference}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={thirdPartyCorrespondence.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={thirdPartyCorrespondence.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={thirdPartyCorrespondence.licenceDetails?.reg_no}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ThirdPartyCorrespondenceHeader;
